/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const sendEmail = /* GraphQL */ `
  mutation SendEmail($email: String, $fullName: String, $message: String) {
    sendEmail(email: $email, fullName: $fullName, message: $message)
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
      name
      shortName
      users {
        items {
          id
          firstName
          lastName
          username
          email
          orgID
          cognitoID
          createdAt
          updatedAt
        }
        nextToken
      }
      websites {
        items {
          id
          orgID
          domain
          createdAt
          updatedAt
        }
        nextToken
      }
      clientLeads
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
      name
      shortName
      users {
        items {
          id
          firstName
          lastName
          username
          email
          orgID
          cognitoID
          createdAt
          updatedAt
        }
        nextToken
      }
      websites {
        items {
          id
          orgID
          domain
          createdAt
          updatedAt
        }
        nextToken
      }
      clientLeads
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $input: DeleteOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    deleteOrganization(input: $input, condition: $condition) {
      id
      name
      shortName
      users {
        items {
          id
          firstName
          lastName
          username
          email
          orgID
          cognitoID
          createdAt
          updatedAt
        }
        nextToken
      }
      websites {
        items {
          id
          orgID
          domain
          createdAt
          updatedAt
        }
        nextToken
      }
      clientLeads
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      username
      email
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      cognitoID
      requests {
        items {
          id
          status
          userID
          ticketID
          redboothID
          title
          websiteID
          urgent
          dueDate
          orgID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      username
      email
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      cognitoID
      requests {
        items {
          id
          status
          userID
          ticketID
          redboothID
          title
          websiteID
          urgent
          dueDate
          orgID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      username
      email
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      cognitoID
      requests {
        items {
          id
          status
          userID
          ticketID
          redboothID
          title
          websiteID
          urgent
          dueDate
          orgID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createWebsite = /* GraphQL */ `
  mutation CreateWebsite(
    $input: CreateWebsiteInput!
    $condition: ModelWebsiteConditionInput
  ) {
    createWebsite(input: $input, condition: $condition) {
      id
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      domain
      createdAt
      updatedAt
    }
  }
`;
export const updateWebsite = /* GraphQL */ `
  mutation UpdateWebsite(
    $input: UpdateWebsiteInput!
    $condition: ModelWebsiteConditionInput
  ) {
    updateWebsite(input: $input, condition: $condition) {
      id
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      domain
      createdAt
      updatedAt
    }
  }
`;
export const deleteWebsite = /* GraphQL */ `
  mutation DeleteWebsite(
    $input: DeleteWebsiteInput!
    $condition: ModelWebsiteConditionInput
  ) {
    deleteWebsite(input: $input, condition: $condition) {
      id
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      domain
      createdAt
      updatedAt
    }
  }
`;
export const createRequest = /* GraphQL */ `
  mutation CreateRequest(
    $input: CreateRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    createRequest(input: $input, condition: $condition) {
      id
      status
      userID
      user {
        id
        firstName
        lastName
        username
        email
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        cognitoID
        requests {
          nextToken
        }
        createdAt
        updatedAt
      }
      ticketID
      redboothID
      title
      websiteID
      website {
        id
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        domain
        createdAt
        updatedAt
      }
      urgent
      dueDate
      files {
        items {
          id
          requestID
          name
          s3Key
          createdAt
          updatedAt
        }
        nextToken
      }
      pages {
        items {
          id
          requestID
          url
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateRequest = /* GraphQL */ `
  mutation UpdateRequest(
    $input: UpdateRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    updateRequest(input: $input, condition: $condition) {
      id
      status
      userID
      user {
        id
        firstName
        lastName
        username
        email
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        cognitoID
        requests {
          nextToken
        }
        createdAt
        updatedAt
      }
      ticketID
      redboothID
      title
      websiteID
      website {
        id
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        domain
        createdAt
        updatedAt
      }
      urgent
      dueDate
      files {
        items {
          id
          requestID
          name
          s3Key
          createdAt
          updatedAt
        }
        nextToken
      }
      pages {
        items {
          id
          requestID
          url
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteRequest = /* GraphQL */ `
  mutation DeleteRequest(
    $input: DeleteRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    deleteRequest(input: $input, condition: $condition) {
      id
      status
      userID
      user {
        id
        firstName
        lastName
        username
        email
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        cognitoID
        requests {
          nextToken
        }
        createdAt
        updatedAt
      }
      ticketID
      redboothID
      title
      websiteID
      website {
        id
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        domain
        createdAt
        updatedAt
      }
      urgent
      dueDate
      files {
        items {
          id
          requestID
          name
          s3Key
          createdAt
          updatedAt
        }
        nextToken
      }
      pages {
        items {
          id
          requestID
          url
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFile = /* GraphQL */ `
  mutation CreateFile(
    $input: CreateFileInput!
    $condition: ModelFileConditionInput
  ) {
    createFile(input: $input, condition: $condition) {
      id
      requestID
      name
      s3Key
      createdAt
      updatedAt
    }
  }
`;
export const updateFile = /* GraphQL */ `
  mutation UpdateFile(
    $input: UpdateFileInput!
    $condition: ModelFileConditionInput
  ) {
    updateFile(input: $input, condition: $condition) {
      id
      requestID
      name
      s3Key
      createdAt
      updatedAt
    }
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile(
    $input: DeleteFileInput!
    $condition: ModelFileConditionInput
  ) {
    deleteFile(input: $input, condition: $condition) {
      id
      requestID
      name
      s3Key
      createdAt
      updatedAt
    }
  }
`;
export const createPage = /* GraphQL */ `
  mutation CreatePage(
    $input: CreatePageInput!
    $condition: ModelPageConditionInput
  ) {
    createPage(input: $input, condition: $condition) {
      id
      requestID
      url
      description
      createdAt
      updatedAt
    }
  }
`;
export const updatePage = /* GraphQL */ `
  mutation UpdatePage(
    $input: UpdatePageInput!
    $condition: ModelPageConditionInput
  ) {
    updatePage(input: $input, condition: $condition) {
      id
      requestID
      url
      description
      createdAt
      updatedAt
    }
  }
`;
export const deletePage = /* GraphQL */ `
  mutation DeletePage(
    $input: DeletePageInput!
    $condition: ModelPageConditionInput
  ) {
    deletePage(input: $input, condition: $condition) {
      id
      requestID
      url
      description
      createdAt
      updatedAt
    }
  }
`;
